<template>
  <Modal title="封禁注册学生" v-model="visible">
    <Form ref="bannedUserForm" class="form"
      :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item label="学生">
            <Tag v-for="item in userList" :key="item.id" :name="item.id" >
              {{ item.id + ' - ' + item.nickname + ' - ' + item.ip}}
            </Tag>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingBannedUser" @click="bannedUser">封禁</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'BannedUserModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      userList: {
        type: Array
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingBannedUser: false,
      }
    },
    methods: {
      bannedUser () {
        let self = this

        let idList = self.userList.map(function (element) {
          if (element.uid) {
            return element.uid
          }
          return element.id
        })
        self.loadingBannedUser = true
        let params = {ids: idList.join(',')}
        self.$http.get('/user/banned', {params: params}).then(function (res) {
          if (res && res.data > 0) {
            self.successCallback()
            self.visible = false
          }
          self.loadingBannedUser = false
        }).catch(function (e) {
          self.visible = false
          self.loadingBannedUser = false
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BannedUserModal.vue?5575ea73